export const GENERAL_FIELDS = {
  SELECTED_ID: {api_name: 'selectedId', required: false, label: 'Selected Id', display_label: 'Selected Id'},
  SELECTED_VALUE: {api_name: 'selectedValue', required: false, label: 'Selected Value', display_label: 'Selected Value'},
}